export default {"src":"/_next/static/media/unpublished-dark.76e72d08.svg","height":256,"width":256};